export function resolveWebchatUrl(envUrl: string | undefined): string {
  if (!envUrl) return '/webchat'
  return `${envUrl.replace(/\/+$/, '')}/webchat`
}
